import getParsedFields from './getParsedFields'
import mountTemplateData from './mountTemplateData'
import transformComponents from './transformComponents'
import formStatusLabel from './formStatusLabel'
import formChipColor from './formChipColor'
import legalFrameworkLabel from './legalFrameworkLabel'

export default {
  getParsedFields,
  mountTemplateData,
  transformComponents,
  formStatusLabel,
  formChipColor,
  legalFrameworkLabel,
}
